import { Component } from '@angular/core';
import { BaseButtonComponent } from '../base-button';

@Component({
  selector: 'app-preview-button',
  templateUrl: './preview-button.component.html',
  styleUrls: ['./preview-button.component.scss', '../base-button.scss'],
})
export class PreviewButtonComponent extends BaseButtonComponent {
  preview() {
    const wnd = window.open();
    this.apiService
      .getRecordPreview(this.record.id, this.issueDate, this.rhId)
      .subscribe((preview) => (wnd.location.href = preview.previewUrl));
  }
}
